"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarItemNested = void 0;

var _react = _interopRequireDefault(require("react"));

var _flex = _interopRequireDefault(require("@waglabs/flex"));

var _link = _interopRequireDefault(require("@waglabs/link"));

var _text = _interopRequireDefault(require("@waglabs/text"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SidebarItemNested = function SidebarItemNested(_ref) {
  var route = _ref.route,
      rest = _objectWithoutProperties(_ref, ["route"]);

  return _react["default"].createElement(_flex["default"], _extends({
    flexDirection: "column"
  }, rest), _react["default"].createElement(_text["default"], {
    color: "wagGray",
    fontFamily: "body",
    textTransform: "uppercase",
    fontWeight: "bold",
    m: 0,
    px: 3,
    pt: 3,
    pb: 9
  }, route.label), route.subRoutes.map(function (subRoute) {
    return _react["default"].createElement(_link["default"], {
      key: subRoute.key,
      href: subRoute.url
    }, _react["default"].createElement(_text["default"], {
      hover: true,
      color: "medGray",
      fontFamily: "body",
      ml: 30,
      display: "inline-block"
    }, subRoute.label));
  }));
};

exports.SidebarItemNested = SidebarItemNested;